import { cashierMoney, salesByDay, salesByRegister, type SalesLine } from '../model/analytics'
import type { AnalyticsSummary } from '../model/types'

const dayText = (day: string) => `${day.slice(8, 10)}.${day.slice(5, 7)}.${day.slice(0, 4)}`
const rubles = (cents: number | null, complete = true) => cents === null ? '—' : `${complete ? '' : '≥ '}${cashierMoney(cents / 100)}`
const cells = (line: SalesLine) => <>
  <td>{line.sales}</td><td title="Часть чека оплачена наличными, часть картой: суммы разнесены по столбцам «Наличные» и «Безналичные»">{line.mixed === null ? '—' : line.mixed}</td><td>{rubles(line.cash)}</td><td>{rubles(line.card)}</td><td><strong>{rubles(line.total, line.complete)}</strong></td>
</>
const head = (first: string) => <thead><tr><th scope="col">{first}</th><th scope="col">Чеков всего</th><th scope="col">Смешанных</th><th scope="col">Наличные</th><th scope="col">Безналичные</th><th scope="col">Итого</th></tr></thead>

/**
 * Итоги кассира за выбранный период. «По кассам» — всегда: источник, касса, чеки, наличные, безналичные и итого (приход минус
 * возврат). «По дням» — только когда выбрано несколько дней: за один день такая таблица из одной строки ничего не добавляет.
 */
export function SalesBreakdown({ summary, from, to, place }: { summary: AnalyticsSummary | undefined; from: string; to: string; place: string }) {
  if (summary === undefined) return null
  const registers = salesByRegister(summary, from, to, place)
  const days = from === to ? [] : salesByDay(summary, from, to, place)
  const period = from === to ? dayText(from) : `${dayText(from)} — ${dayText(to)}`
  return <div className="cashier-sales">
    <section aria-label="Итоги по кассам">
      <h3>Итоги по кассам · {period}</h3>
      {registers.rows.length === 0 ? <p role="status">Нет продаж</p> : <div className="krp-receipt-table-wrap"><table className="krp-receipt-table cashier-sales__table">
        {head('Касса')}
        <tbody>{registers.rows.map((row) => <tr key={row.key}>
          <th scope="row"><strong>{row.registerName}</strong><small>{[row.sourceName, row.shopName.trim()].filter((part) => part !== '').join(' · ')}</small></th>
          {cells(row)}
        </tr>)}</tbody>
        {registers.rows.length > 1 && <tfoot><tr><th scope="row">Всего</th>{cells(registers.total)}</tr></tfoot>}
      </table></div>}
    </section>
    {days.length > 1 && <section aria-label="Итоги по дням">
      <h3>По дням</h3>
      <div className="krp-receipt-table-wrap"><table className="krp-receipt-table cashier-sales__table">
        {head('День')}
        <tbody>{days.map((row) => <tr key={row.day}><th scope="row">{dayText(row.day)}</th>{cells(row)}</tr>)}</tbody>
      </table></div>
    </section>}
  </div>
}
